<template>
  <div class="show" v-if="showInfo">
    <div class="weixin-tip">
      <p>
        <img src="/static/img/live_weixin.png" alt="微信打开"/>
      </p>
	</div>
    <div class="box">
      <div class="logo">
          <img :src="`${IP_TEST}/uploads/${logopic}`" alt="" @click="$router.push('/')">
        </div>
      <div class="content">
        <div class="typecontent">
          <h2>
            培训单位备案信息
          </h2>
         <span @click="$router.push('/')"  style="margin-right: 20px;">返回主页</span>
        </div>
        <div class="headerinfo">
          <img src="/static/img/gognsi1.png" alt="">
          <div class="compytitle">
            <h3>
              {{ showInfo.companyname }}
            </h3>
            <p>
              <i class="el-icon-location-outline"></i>{{ showInfo.address }}
            </p>
          </div>
        </div>
        <div class="codeinfo">
          <img src="/static/img/huiayun.png" alt="">
          <span>备案登记号：{{ showInfo.code }}</span>
        </div>
        <div class="detailInfo">
          <table>
            <tr>
              <td>法定代表人：</td>
              <td>{{ showInfo.legalperson }}</td>
            </tr>
            <tr>
              <td>信用代码：</td>
              <td>{{ showInfo.socialcreditcode }}</td>
            </tr>
            <tr>
              <td>所属行业：</td>
              <td>{{ showInfo.industry }}</td>
            </tr>
            <tr>
              <td>单位所属地址：</td>
              <td>{{ showInfo.country }}</td>
            </tr>
            <tr>
              <td>单位注册地址：</td>
              <td >{{ showInfo.address }}</td>
            </tr>
            <tr>
              <td>登记项目名称：</td>
              <td >{{ showInfo.beianname }}</td>
            </tr>
            <tr>
              <td>项目组意见：</td>
              <td >{{ showInfo.committeeppinion }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
/**
 * 企业证书查询系统模版
 */
import { IP_TEST } from '@/config';
import QRCode from "qrcodejs2";
export default {
  name: "ShowQy",
  data() {
    return {
      IP_TEST
    }
  },
  computed:{
    logopic() {
      return this.$store.getters.logopic;
    }
  },
  props: {
    showInfo: Object
  },
  mounted() {
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    download() {
      this.$axios
        .get(`${IP_TEST}/uploads/证书图下载/${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.socialcreditcode}.jpg`, {
          responseType: "blob", //重要
        })
        .then((response) => {
          if ("msSaveOrOpenBlob" in window.navigator) {
            //兼容ie浏览器下载报传递给系统调用的数据区域太小.
            var data = response;
            var blob = new Blob([data], { type: "application/vnd.ms-excel" });
            window.navigator.msSaveOrOpenBlob(blob, `${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.socialcreditcode}.jpg`);
            return;
          } else {
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS&&!this.isWeixinBrowser()) {
              var jpeg = new Blob([response], { type: "image/jpeg" });
              const url = window.URL.createObjectURL(jpeg);
              const link = document.createElement("a");
              let fname = `${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.socialcreditcode}.jpg`;
              link.href = url;
              link.setAttribute("download", fname);
              link.download = fname;
              document.body.appendChild(link);
              link.click();
              return;
            }
            else if(isiOS&&this.isWeixinBrowser())
            {
              var winHeight = $(window).height();
              $(".weixin-tip").css("height",winHeight);
              $(".weixin-tip").show();
              return;
            }
            window.open(
              `${IP_TEST}/bzw/loadimgs?imgpath=证书图下载/${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.socialcreditcode}.jpg`,
              "_blank"
            );
          }
        });
    },
    isWeixinBrowser() {
      return /micromessenger/.test(navigator.userAgent.toLowerCase())
        ? true
        : false;
    },
    isQQBrowser() {
      return /qq/.test(navigator.userAgent.toLowerCase()) ? true : false;
    },
    formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
    },
    formatExcel(value) {
        if (!value) {
            return "";
        } else {
            if (typeof value == "string") {
                return value.trim();
            } else {
                return value.toString().trim();
            }
        }
    }
  }
};
</script>
<style scoped>
.show{
  position: relative;
  width:100vw;
  min-height: 1213px;
    background-image: url(/static/img/bgjieguo.png);
    background-size: cover;
    padding-bottom: 71px;
}
.show .box{
  width: 94vw;
  margin: auto;
  position: relative;
  top:47px;
}
.logo{
  width: 90vw;
}
.content .headerinfo{
  min-height: 121px;
  display: flex;
  /* margin-top:65px; */
  background: rgba(21, 0, 125, 0.3);
  padding: 18px 0 0 10px;
  margin-top:39px
}
.content .headerinfo img{
  display: inline-block;
  width: 91px;
  height: 91px;
}
.content .headerinfo h2{
  background-image: url(/static/img/baiotiti.png);
    background-repeat: no-repeat;
    background-size: contain;
   min-height: 92px;
    width: 465px;
    margin: auto;
    position: relative;
    top: 50px;
    font-size: 36px;
    text-align: center;
    line-height: 92px;
font-weight: bold;
color: #FFFFFF;
}
.compytitle{
    min-height: 91px;
    width: 450px;
    position: relative;
    left: 10px;
    border-radius: 5px;
    display: inline-block;
}
.compytitle h3{
    font-size: 20px;
  /* font-weight: bold; */
  color: #FFFFFF;
  letter-spacing: 4px;
}
.content .typecontent span{
  color: #fff;
    float: right;
    line-height: 44px;
    height: 41px;
    font-size: 16px;
}
.compytitle p{
  height: 22px;
    overflow: hidden;
    font-size: 21px;
    font-weight: 400;
    margin-top: 33px;
    color: #CDCCD8;
    letter-spacing: 3px;
    -webkit-background-clip: text;
    word-break: break-all;
-webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
-webkit-line-clamp: 1;
}
.codeinfo{
  margin-top: 3px;
  width: 94vw;
  height: 65px;
  background: rgba(21, 0, 125, 0.3);
  line-height: 65px;
  font-size: 24px;
  color: #FFFFFF;
  letter-spacing: 3px;
  border-radius: 5px;
}
.codeinfo img{
  margin-left: 28px;
  margin-right: 12px;
  position: relative;
    top: 19px;
}
.detailInfo{
  margin-top:20px;
  width: 94vw;
  min-height: 255px;
  background: rgba(21, 0, 125, 0.3);
  border-radius: 5px;
  /* padding: 12px 2vw 28px 2vw; */

}

.detailInfo td{
  border:1px solid RGBA(7, 84, 185, 1);
  /* padding:5px 15px; */
  min-height: 54px;
  height: 54px;
  padding-left: 10px;
  font-size: 21px;
  line-height: 33px;
}
.detailInfo tr td:nth-child(2n-1){
  font-size: 18px;
color: #FFFFFF;
  width: 179px;
}
.detailInfo tr td:nth-child(2n){
  width: 469px;
  font-size: 18px;
  color: #FFFFFF;
}
.content .typecontent h2{
  background-image: url(/static/img/baiotiti.png);
    background-repeat: no-repeat;
    background-size: contain;
    height: 80px;
    width: 41vw;
    /* margin: auto; */
    position: relative;
    top: 50px;
    font-size: 20px;
    text-align: center;
    line-height: 46px;
    letter-spacing: 5px;
    color: #FFFFFF;
}
.content .typecontent span{
  color: #fff;
    float: right;
    line-height: 44px;
    height: 35px;
    position: relative;
    font-size: 16px;
    right: 0px;
    top: -33px;
}
</style>